import type { IssueStatus, UserRole } from '../types'

const READY_FOR_NEXT_STAGE_STATUS_NAME = 'ready for next stage'
const DONE_STATUS_NAME = 'done'

export function isReadyForNextStageStatus(name?: string | null): boolean {
  return (name || '').trim().toLowerCase() === READY_FOR_NEXT_STAGE_STATUS_NAME
}

export function isDoneStatus(name?: string | null): boolean {
  return (name || '').trim().toLowerCase() === DONE_STATUS_NAME
}

export function requiresStatusDetailsPopup({
  currentStatusName,
  nextStatusName,
  userRole,
}: {
  nextStatusName?: string | null
  currentStatusName?: string | null
  userRole?: UserRole
}): boolean {
  if (!(nextStatusName || '').trim()) {
    return false
  }

  if (isReadyForNextStageStatus(nextStatusName) || isDoneStatus(nextStatusName)) {
    return true
  }

  if (userRole === 'TESTER' && isReadyForNextStageStatus(currentStatusName)) {
    return true
  }

  return false
}

export function confirmReadyForNextStageChange({
  currentStatusId,
  nextStatusId,
  statuses,
  labelNames,
}: {
  currentStatusId?: string
  nextStatusId: string
  statuses: IssueStatus[]
  labelNames: string[]
}): boolean {
  if (!nextStatusId || nextStatusId === currentStatusId) return true

  const nextStatus = statuses.find((status) => status.id === nextStatusId)
  if (!nextStatus || !isReadyForNextStageStatus(nextStatus.name)) return true

  if (labelNames.length === 0) {
    window.alert('Please select a label before moving this issue to Ready for Next Stage.')
    return false
  }

  const labelText = labelNames.join(', ')
  return window.confirm(
    `This issue is moving to Ready for Next Stage with label: ${labelText}. Please confirm the label is correct.`
  )
}
